import React, { ErrorInfo } from 'react'
import { Pageheader } from './pageheader'

export const ErrorPage = (props: { error: [Error, ErrorInfo] }) => (
  <>
    <Pageheader title="Error log" />
    <div className="">
      <div className="">
        <h2 className="">{props.error[0].name}</h2>
        <p className="">{props.error[0].message}</p>

        <small className="" style={{ fontSize: 12, lineHeight: 1.5 }}>
          {props.error[0].stack}
        </small>
      </div>
    </div>
  </>
)
